export default function initScrollDetector() {
  let lastScrollY = window.scrollY;
  let isScrollingUp = false;

  window.addEventListener("scroll", function () {
    let scrolled = window.scrollY;
    if (scrolled > 0) {
      document.body.classList.add("scrolled");
      isScrollingUp = scrolled < lastScrollY;
      if (isScrollingUp) {
        document.body.classList.add("scrolled-up");
      } else {
        document.body.classList.remove("scrolled-up");
      }
    } else {
      document.body.classList.remove("scrolled");
      document.body.classList.remove("scrolled-up");
    }
    lastScrollY = scrolled;
  });
}
